'use strict';
var parent = require('../../es/object/get-own-property-descriptor');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/object/get-own-property-descriptor.js
// module id = 775
// module chunks = 13